import React, { useCallback } from 'react'

import cx from '../../../utils/className'
import styles from './SelectIcon.module.css'

const TYPE = {
  RADIO: styles.radio,
  CHECKBOX: styles.checkbox
}

const SelectIcon = (props) => {
  const {
    type: typeProp,
    selected,
    disabled,
    onClick,
    className,
    ariaLabel,
    ariaLabelledby,
    visualOnly
  } = props

  const typeClassName = typeProp || TYPE.RADIO
  const isRadio = typeClassName === TYPE.RADIO
  const role = isRadio ? 'radio' : 'checkbox'

  const handleClick = onClick || (() => null)

  const handleKeyDown = useCallback(
    (e) => {
      if (disabled) return
      if (e.key !== ' ' && e.key !== 'Enter') return
      e.preventDefault()
      handleClick(e)
    },
    [disabled, handleClick]
  )

  const iconClass = cx(styles.icon, typeClassName, (selected && !disabled) ? styles.selected : null, className || null)

  if (visualOnly) {
    return (
      <div
        aria-hidden="true"
        onClick={disabled ? undefined : handleClick}
        className={iconClass}
      />
    )
  }

  if (process.env.NODE_ENV !== 'production' && !ariaLabel && !ariaLabelledby) {
    // eslint-disable-next-line no-console
    console.warn('[SelectIcon] Provide ariaLabel or ariaLabelledby for screen readers.')
  }

  return (
    <div
      role={role}
      aria-checked={selected}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled ? true : undefined}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      onClick={disabled ? undefined : handleClick}
      onKeyDown={handleKeyDown}
      className={iconClass}
    />
  )
}

SelectIcon.TYPE = TYPE

export default SelectIcon
